import React from 'react'
import { Link } from 'react-router-dom'

function CreateEvent() {
  return (
    <div className='h-screen background'>
        <div className='absolute bottom-[300px] flex flex-col items-center'>
            <h3 className='text-2xl font-bold'>Ahoy!</h3>
            <p className='px-10 text-center text-xs mt-8'>Lorem ipsum dolor sit amet consectetur. Ut cursus adipiscing dolor velit. Viverra tristique et et nunc nulla pharetra vel arcu ut.</p>
        
        </div>
        <div className='absolute bottom-40 flex flex-col items-center w-full space-y-5'>
            <button className='px-20 py-3 bg-white font-semibold text-black rounded-3xl'>Create Event</button>
            <Link to='/createeventfield' className='px-20 py-3 bg-white font-semibold text-black rounded-3xl'>Join Event</Link>
        </div>
    </div>
  )
}

export default CreateEvent